import VibratingButton from "@/components/base/button/VibratingButton";

interface ImageOption {
  id: string;
  title: string;
  image?: string | null;
}

interface Props {
  options: ImageOption[];
  value: string;
  onChange: (id: string) => void;
}

const ImageBased = ({ options, value, onChange }: Props) => {
  return (
    <div className="grid grid-cols-2  gap-2 w-full">
      {options?.map((item) => {
        const isSelected = value === item.id;

        return (
          <VibratingButton
            key={item.id}
            vibrationType="selection"
            className={`p-px rounded-xl w-full cursor-pointer transition-300 ${
              isSelected
                ? "bg-yellow-linear shadow-[0_7px_33px_-24px_rgba(235,161,50,0.24)]"
                : "bg-transparent"
            }`}
            onClick={() => onChange(item.id)}
          >
            <div className="bg-gray-4 rounded-xl">
              <div
                className={`w-full rounded-xl transition-300 flex flex-col items-center relative ${
                  isSelected
                    ? "bg-[linear-gradient(83deg,rgba(251,199,108,0.08)_-31px,rgba(235,161,50,0.08)_100px)]"
                    : "bg-gray-4"
                }`}
              >
                {/* Radio — aynan CheckBox stilida */}
                <div className={`absolute top-3 right-3 z-10 w-6 h-6 rounded-full border flex items-center justify-center transition-200 shadow-sm ${
                  isSelected ? "bg-yellow-linear border-orange-100 " : "border-white/08 bg-gray-4/50 backdrop-blur-sm"
                }`}>
                  {isSelected && <div className="w-3 h-3 rounded-full bg-white" />}
                </div>

                {item.image && (
                  <div className="w-full h-[140px] aspect-square rounded-lg overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full  h-[140px] rounded-xl object-cover"
                    />
                  </div>
                )}
                {item.title && (
                  <p className="text-xs font-semibold text-white leading-4 text-start truncate w-full px-2 py-1">
                    {item.title}
                  </p>
                )}
              </div>
            </div>
          </VibratingButton>
        );
      })}
    </div>
  );
};

export default ImageBased;
